import FilterSearch from '@Components/Filter/Search';
import Modal from '@Components/Modal';
import { SBTable } from '@Components/Table/Table';
import { TableHeadCell, TableRowCell } from '@Components/Table/TableCell';
import { SBTableRow } from '@Components/Table/TableRow';
import CloseIcon from '@mui/icons-material/Close';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import {
  Button,
  Grid,
  IconButton,
  InputLabel,
  TableBody,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  CircularProgress,
} from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import API from '@Services/apiAxios';
import SBDropdown from '@Components/Dropdown';
import { DropdownOptionType } from '@Components/Dropdown/Type';
import SbButton from '@Components/Button';
import { SbSwitch } from '@Components/Switch';
import {
  assignTaskToSquad,
  getAllTaskShipments,
  getSquadForTaskAssignment,
  BulkAssignTaskToSquad,
} from '@Reducers/Squad/actions';
import { AppDispatch, RootStateType } from '@Store';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { assignClickProps, SquadMemberTableProps, BulkAssignTaskToSquadPayload } from './types';
import { SuccessErrorModalOpen, SuccessErrorModalReset } from '@Reducers/SuccessErrorModal';
import DisplaySquadVehicle from '../../utils/displaySquadVehicle';
import Loader from '@Components/Loader';
import { SquadMembersPayload } from '../../store/reducers/Squad/type';
import { setSelectedTasks, setBulkShipmentIdArray } from '@Reducers/Squad';
import { Dayjs } from 'dayjs';
interface AssignModalProps {
  open: boolean;
  onClose: () => void;
  shipmentId?: string;
  shipmentNumber?: string;
  isBulkAssign: boolean;
  date: Dayjs;
  selectedZones: string[];
}
const SearchFilterList = [{ label: 'Name', value: 'name' }];

function SquadMemberTable(props: SquadMemberTableProps) {
  const { allSquads, shipmentId, close, isBulkAssign, date, setLoading } = props;
  const { bulkShipmentIdArray } = useSelector((state: RootStateType) => state.squadManagement);

  const dispatch = useDispatch<AppDispatch>();
  const onAssignClick = async (props: assignClickProps) => {
    const { _shipmentId, assignedTo } = props;
    const postData = {
      _shipmentId,
      assignedTo,
      date,
    };

    try {
      setLoading(true);
      const data = await dispatch(assignTaskToSquad(postData)).unwrap();
      if (data.warningMessage) {
        dispatch(
          SuccessErrorModalOpen({
            type: 'success',
            title: 'Shipment is successfully assigned!',
            subTitle: `${data.warningMessage}`,
          }),
        );
      } else {
        dispatch(
          SuccessErrorModalOpen({
            type: 'success',
            title: 'Shipment is successfully assigned!',
            subTitle: '',
          }),
        );
      }
      setLoading(false);
      close();

      await dispatch(getAllTaskShipments({ page: 1, pageSize: 10, shipmentNumber: '' }));
    } catch (err) {
      setLoading(false);
    }
  };
  const BulkAssign = async (props: BulkAssignTaskToSquadPayload) => {
    const { assignedTo } = props;
    const postData = {
      shipmentIdArray: bulkShipmentIdArray.map(shipment => shipment._shipmentId),
      assignedTo,
      date,
    };
    try {
      setLoading(true);
      await dispatch(BulkAssignTaskToSquad(postData)).unwrap();
      dispatch(
        SuccessErrorModalOpen({
          type: 'success',
          title: 'Bulk Shipments successfully assigned!',
          subTitle: '',
        }),
      );
      dispatch(setSelectedTasks({}));
      dispatch(setBulkShipmentIdArray([]));
      close();
      setLoading(false);

      await dispatch(getAllTaskShipments({ page: 1, pageSize: 10, shipmentNumber: '' }));
    } catch (err) {
      setLoading(false);
      dispatch(
        SuccessErrorModalOpen({
          type: 'error',
          title: 'Error',
          subTitle: 'Something went wrong',
        }),
      );
    }
    close();
  };

  return (
    <SBTable>
      <TableHead>
        <TableRow>
          <TableHeadCell is_light="1" className="bg-grey">
            Name
          </TableHeadCell>
          <TableHeadCell is_light="1" className="bg-grey">
            UserName
          </TableHeadCell>
          <TableHeadCell is_light="1" className="bg-grey">
            Vehicle
          </TableHeadCell>
          <TableHeadCell is_light="1" className="bg-grey">
            Actions
          </TableHeadCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {allSquads?.map((data: any) => {
          const { name, phoneNumber, username, vehicle, vehicleCapacity, isAlreadyAssigned, id } = data;
          return (
            <SBTableRow key={Number(id)}>
              <TableRowCell align="center">
                <div>
                  <Typography>
                    {name}
                    <br />
                    {phoneNumber}
                  </Typography>
                </div>
              </TableRowCell>
              <TableRowCell align="center" className="md-text">
                <Typography>{username}</Typography>
              </TableRowCell>
              <TableRowCell align="center" className="md-text ">
                <Box className="flex flex-col sb-gap-1">
                  <Typography>{DisplaySquadVehicle(vehicle)} </Typography>
                  <Typography> Capacity : {vehicleCapacity} kg</Typography>
                </Box>
              </TableRowCell>
              <TableRowCell align="center" className="md-text ">
                {isAlreadyAssigned ? (
                  <Button variant="contained" className="rounded-xs">
                    Unassign
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    className="rounded-xs"
                    onClick={() => {
                      if (isBulkAssign && bulkShipmentIdArray.length > 0) {
                        BulkAssign({
                          assignedTo: id,
                        });
                      } else {
                        onAssignClick({ _shipmentId: shipmentId, assignedTo: id });
                      }
                    }}
                  >
                    Assign
                  </Button>
                )}
              </TableRowCell>
            </SBTableRow>
          );
        })}
      </TableBody>
    </SBTable>
  );
}

const AssignModal = (props: AssignModalProps) => {
  const [value, setValue] = useState('1');
  const [filterSelectValue, setFilterSelectValue] = useState('name');
  const [filterText, setFilterText] = useState('');
  const [allSquads, setAllSquads] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setLoading] = useState(false);

  const dispatch = useDispatch<AppDispatch>();
  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const { currentPage, perPage, loading } = useSelector((state: RootStateType) => state.squadManagement);
  const handleClose = () => {
    props.onClose();
  };

  const { selectedTasks } = useSelector((state: RootStateType) => state.squadManagement);

  const [cspOptions, setCspOptions] = useState<DropdownOptionType[]>([]);
  const [warehouseOptions, setWarehouseOptions] = useState<DropdownOptionType[]>([]);
  const [loadingCsp, setLoadingCsp] = useState(false);
  const [loadingWarehouse, setLoadingWarehouse] = useState(false);
  const [cspFetchError, setCspFetchError] = useState('');
  const [warehouseFetchError, setWarehouseFetchError] = useState('');
  const [assignError, setAssignError] = useState('');

  const [selectedCsp, setSelectedCsp] = useState<string>('');
  const [selectedWarehouse, setSelectedWarehouse] = useState<string>('');
  const [serviceType, setServiceType] = useState<string>('');
  const [sendOtp, setSendOtp] = useState<'True' | 'False'>('False');
  const [cspTouched, setCspTouched] = useState(false);
  const [warehouseTouched, setWarehouseTouched] = useState(false);
  const [serviceTypeTouched, setServiceTypeTouched] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [lastFetchedShipmentNo, setLastFetchedShipmentNo] = useState('');

  const fetchFirstMileVendorShipment = async (shipmentNo: string) => {
    setLoadingCsp(true);
    setLoadingWarehouse(true);
    let savedData = null;
    try {
      const res = await API.get(`/squad/task/firstMileVendorShipment?shipmentNumber=${shipmentNo}`);
      savedData = res.data?.data;
    } catch (err: any) {
      console.error('Error fetching first mile vendor shipment:', err);
    }
    return savedData;
  };

  const fetchCspList = async (savedData?: any) => {
    setLoadingCsp(true);
    setCspFetchError('');
    try {
      const res = await API.get('/squad/task/vendorAccounts');
      const data = res.data?.data || [];
      const options: DropdownOptionType[] = data.map((item: any) => {
        const val = item.csp || item.value || item.id || item._id || '';
        const label = item.name || item.display || item.label || val;
        return { value: val, display: label };
      });
      setCspOptions(options);

      if (savedData && savedData.csp) {
        const matchingCsp = options.find(opt => opt.value === savedData.csp);
        if (matchingCsp) {
          setSelectedCsp(savedData.csp);
          if (savedData.csp === 'velexp') {
            setServiceType(savedData.serviceType || '');
            setSendOtp(savedData.send_otp === 'True' ? 'True' : 'False');
          }
        }
      }
    } catch (err: any) {
      console.error('Error fetching CSP list:', err);
      const errorMsg = err.response?.data?.data?.msg || err.response?.data?.msg || err.message || 'Failed to load CSPs';
      setCspFetchError(errorMsg);
    } finally {
      setLoadingCsp(false);
    }
  };

  const fetchWarehouseList = async (shipmentNo: string, savedData?: any) => {
    setLoadingWarehouse(true);
    setWarehouseFetchError('');
    try {
      const res = await API.post('squad/task/warehouseList', { shipmentNumber: shipmentNo });
      const data = res.data?.data || [];
      const options: DropdownOptionType[] = data.map((item: any) => ({
        value: item._id || '',
        display: item.name || '',
      }));
      setWarehouseOptions(options);

      if (savedData && savedData._warehouseId) {
        const matchingWarehouse = options.find(opt => opt.value === savedData._warehouseId);
        if (matchingWarehouse) {
          setSelectedWarehouse(savedData._warehouseId);
        }
      }
    } catch (err: any) {
      console.error('Error fetching Warehouse list:', err);
      const errorMsg =
        err.response?.data?.data?.msg || err.response?.data?.msg || err.message || 'Failed to load warehouses';
      setWarehouseFetchError(errorMsg);
    } finally {
      setLoadingWarehouse(false);
    }
  };

  const loadForm = async (shipmentNo: string) => {
    const savedData = await fetchFirstMileVendorShipment(shipmentNo);
    await Promise.all([fetchCspList(savedData), fetchWarehouseList(shipmentNo, savedData)]);
  };

  useEffect(() => {
    if (value === '2') {
      const shipmentNo = props.isBulkAssign ? Object.keys(selectedTasks)[0] : props.shipmentNumber;

      if (shipmentNo && shipmentNo !== lastFetchedShipmentNo) {
        setSelectedCsp('');
        setSelectedWarehouse('');
        setServiceType('');
        setSendOtp('False');
        setCspTouched(false);
        setWarehouseTouched(false);
        setServiceTypeTouched(false);
        setAssignError('');

        loadForm(shipmentNo);
        setLastFetchedShipmentNo(shipmentNo);
      }
    }
  }, [value, props.isBulkAssign, props.shipmentNumber, selectedTasks, lastFetchedShipmentNo]);

  const handleSubmit = async () => {
    setCspTouched(true);
    setWarehouseTouched(true);
    if (selectedCsp === 'velexp') {
      setServiceTypeTouched(true);
    }

    if (!selectedCsp) {
      return;
    }
    if (!selectedWarehouse) {
      return;
    }
    if (selectedCsp === 'velexp' && !serviceType) {
      return;
    }

    setIsSubmitting(true);
    setAssignError('');

    const shipmentNumber = props.isBulkAssign ? Object.keys(selectedTasks) : [props.shipmentNumber || ''];

    const postData: any = {
      shipmentNumber,
      csp: selectedCsp,
      _warehouseId: selectedWarehouse,
    };

    if (selectedCsp === 'velexp') {
      postData.serviceType = serviceType;
      postData.send_otp = sendOtp;
    }

    try {
      const res = await API.post('/squad/task/assignToCarrier', postData);
      const successMsg = res.data?.data?.msg || res.data?.msg || 'Carrier assigned successfully!';
      dispatch(
        SuccessErrorModalOpen({
          type: 'success',
          title: res?.data?.msg || 'Carrier assigned successfully!',
          subTitle: successMsg,
          onConfirm: () => {
            props.onClose();
            dispatch(SuccessErrorModalReset());
          },
        }),
      );
      dispatch(setSelectedTasks({}));
      dispatch(setBulkShipmentIdArray([]));
      // props.onClose();
    } catch (err: any) {
      console.error('Error assigning carrier:', err);
      const errorMsg =
        err.response?.data?.data?.msg || err.response?.data?.msg || err.message || 'Something went wrong';
      setAssignError(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  const fetchSquadForAssignment = async (name: string, currentPage: number, perPage: number) => {
    const queryParams = {
      name,
      shipmentId: props.shipmentId || '',
      currentPage,
      perPage,
      zoneName: props.selectedZones,
    };
    const result = await dispatch(getSquadForTaskAssignment(queryParams));
    const { data, totalCount } = result.payload as SquadMembersPayload;
    setTotalCount(totalCount);
    setAllSquads(data);
  };

  useEffect(() => {
    fetchSquadForAssignment('', currentPage, perPage);
  }, []);

  return (
    <>
      <Loader loading={isLoading || loading} overly />
      <Modal open={props.open} onClose={handleClose} maxWidth="md">
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Box sx={{ width: '46rem' }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="lab API tabs example">
                  <Tab label="Squad Member" value="1" className="md-text font-medium" />
                  <Tab label="Third-party Integration" className="md-text font-medium" value="2" />
                </TabList>
              </Box>
              <TabPanel value="1" sx={{ height: '55vh', overflow: 'auto' }}>
                <Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <InputLabel className="sb-text-gray">Enter name or username</InputLabel>
                    </Grid>
                    <Grid item xs={12} sx={{ marginBottom: '1rem' }}>
                      <FilterSearch
                        onSelectChange={(value: string) => {
                          setFilterSelectValue(value);
                        }}
                        list={SearchFilterList}
                        selectValue={filterSelectValue}
                        textValue={filterText}
                        placeholder="sbps@gmail.com"
                        onTextChange={e => {
                          setFilterText(e.target.value);
                        }}
                        onTextSearch={() => {
                          fetchSquadForAssignment(filterText, currentPage, perPage);
                        }}
                        onTextClear={async () => {
                          setFilterText('');
                          fetchSquadForAssignment('', currentPage, perPage);
                        }}
                      />
                    </Grid>
                  </Grid>

                  {props.shipmentId && (
                    <SquadMemberTable
                      allSquads={allSquads}
                      shipmentId={props.shipmentId}
                      close={handleClose}
                      isBulkAssign={props.isBulkAssign}
                      date={props.date}
                      setLoading={setLoading}
                    />
                  )}
                </Box>
              </TabPanel>
              {totalCount > 0 && (
                <TablePagination
                  component="div"
                  count={totalCount}
                  page={currentPage - 1}
                  rowsPerPage={perPage}
                  onPageChange={async (_, page) => {
                    fetchSquadForAssignment(filterText, page + 1, perPage);
                  }}
                  onRowsPerPageChange={async event => {
                    const newPerPage = parseInt(event.target.value, 10);
                    fetchSquadForAssignment(filterText, currentPage, newPerPage);
                  }}
                />
              )}
              <TabPanel value="2" sx={{ height: '55vh', overflow: 'auto', p: 4 }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3.5,
                    width: '100%',
                    maxWidth: '32rem',
                    mx: 'auto',
                  }}
                >
                  <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: 600, color: 'text.primary', mb: 1 }}>
                    Third Party Integration
                  </Typography>

                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <SBDropdown
                      id="select-csp"
                      label="Select CSP"
                      placeholder="Select CSP"
                      required
                      options={cspOptions}
                      value={selectedCsp ? [selectedCsp] : []}
                      onChange={([val]) => {
                        setSelectedCsp(val || '');
                        setCspTouched(true);
                        setServiceType('');
                        setSendOtp('False');
                        setServiceTypeTouched(false);
                      }}
                      disabled={isSubmitting || loadingCsp}
                      error={cspTouched && !selectedCsp ? 'Please select CSP' : ''}
                    />
                    {loadingCsp && (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                        <CircularProgress size={16} />
                        <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>Loading CSPs...</Typography>
                      </Box>
                    )}
                    {!loadingCsp && !cspOptions.length && cspTouched && (
                      <Typography sx={{ fontSize: '12px', color: 'text.secondary', mt: 0.5 }}>
                        No CSP Available
                      </Typography>
                    )}
                  </Box>

                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <SBDropdown
                      id="select-warehouse"
                      label="Select Warehouse Address"
                      placeholder="Select Warehouse"
                      required
                      options={warehouseOptions}
                      value={selectedWarehouse ? [selectedWarehouse] : []}
                      onChange={([val]) => {
                        setSelectedWarehouse(val || '');
                        setWarehouseTouched(true);
                      }}
                      disabled={isSubmitting || loadingWarehouse}
                      error={warehouseTouched && !selectedWarehouse ? 'Please select Warehouse Address' : ''}
                    />
                    {loadingWarehouse && (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                        <CircularProgress size={16} />
                        <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>
                          Loading warehouses...
                        </Typography>
                      </Box>
                    )}
                    {!loadingWarehouse && !warehouseOptions.length && warehouseTouched && (
                      <Typography sx={{ fontSize: '12px', color: 'text.secondary', mt: 0.5 }}>
                        No Warehouse Found
                      </Typography>
                    )}
                  </Box>

                  {selectedCsp === 'velexp' && (
                    <>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <SBDropdown
                          id="select-service-type"
                          label="Service Type"
                          placeholder="Select Service Type"
                          required
                          options={[
                            { display: 'VELOSKY', value: 'VELOSKY' },
                            { display: 'VELOFREIGHT', value: 'VELOFREIGHT' },
                            { display: 'VELODOC', value: 'VELODOC' },
                          ]}
                          value={serviceType ? [serviceType] : []}
                          onChange={([val]) => {
                            setServiceType(val || '');
                            setServiceTypeTouched(true);
                          }}
                          disabled={isSubmitting}
                          error={serviceTypeTouched && !serviceType ? 'Please select Service Type' : ''}
                        />
                      </Box>

                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <SbSwitch
                          label="Send OTP"
                          value={sendOtp === 'True'}
                          onChange={(_, checked) => {
                            setSendOtp(checked ? 'True' : 'False');
                          }}
                          disabled={isSubmitting}
                        />
                      </Box>
                    </>
                  )}

                  {assignError && (
                    <Typography color="error" sx={{ fontSize: '13px', mt: 1, fontWeight: 500 }}>
                      {assignError}
                    </Typography>
                  )}

                  {cspFetchError && (
                    <Typography color="error" sx={{ fontSize: '13px', mt: 1, fontWeight: 500 }}>
                      Failed to fetch CSPs: {cspFetchError}
                    </Typography>
                  )}

                  {warehouseFetchError && (
                    <Typography color="error" sx={{ fontSize: '13px', mt: 1, fontWeight: 500 }}>
                      Failed to fetch warehouses: {warehouseFetchError}
                    </Typography>
                  )}

                  <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2, mt: 3 }}>
                    <SbButton
                      variant="outlined"
                      onClick={handleClose}
                      disabled={isSubmitting}
                      sx={{
                        borderRadius: '6px',
                        px: 3,
                        py: 1,
                        textTransform: 'none',
                        fontSize: '14px',
                        fontWeight: 600,
                      }}
                    >
                      Cancel
                    </SbButton>
                    <SbButton
                      variant="contained"
                      onClick={handleSubmit}
                      disabled={
                        isSubmitting || !selectedCsp || !selectedWarehouse || (selectedCsp === 'velexp' && !serviceType)
                      }
                      sx={{
                        borderRadius: '6px',
                        px: 3,
                        py: 1,
                        textTransform: 'none',
                        fontSize: '14px',
                        fontWeight: 600,
                      }}
                    >
                      {isSubmitting ? 'Assigning...' : 'Assign Shipment'}
                    </SbButton>
                  </Box>
                </Box>
              </TabPanel>
            </TabContext>
          </Box>
          <Box>
            <IconButton onClick={() => handleClose()}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default AssignModal;
